import PropTypes from 'prop-types'
import BaseOverlay from './base-overlay'
import { slideInFromTop } from './transitions'

export default function FullScreenOverlay({
  onDismiss,
  children,
  show,
  dismissOnEscape = false,
}) {
  return (
    <BaseOverlay
      transitions={slideInFromTop}
      className="tw-inset-0 tw-bg-white tw-z-fullscreen-modal tw-fixed"
      onDismiss={onDismiss}
      show={show}
      backdrop={false}
      dismissOnEscape={dismissOnEscape}>
      {children}
    </BaseOverlay>
  )
}

FullScreenOverlay.propTypes = {
  onDismiss: PropTypes.func,
  children: PropTypes.node,
  show: PropTypes.bool,
  dismissOnEscape: PropTypes.bool,
}
